import categurys from "../_ApiConn/apiCategurys";


const addCategury = async (obj) => {
    let dFromF = await categurys.addCategury(obj);
    return (dFromF.data);
}


const removeCategury = async (id) => {
    
    let dFromF = await categurys.removeCategury(id);
    return (dFromF.data);
}

const getAllCategurys = async () => {
    let dFromF = await categurys.getAllCategurys();
    return (dFromF.data);
}

const updateCategury = async (id, obj) => {

    let dFromF = await categurys.updateCategury(id,obj);

    return (dFromF.data);
}

const getCateguryById = async (id) => {
    let dFromF = await categurys.getCateguryById(id);
    return (dFromF.data);
}


const getRestsByCatId = async (id) => {
    let dFromF = await categurys.getRestsByCatId(id);
    return (dFromF.data);
}


export default {
    getAllCategurys,
    getCateguryById,
    getRestsByCatId,
    updateCategury,
    addCategury,removeCategury
    
};